import React, { useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useHistory, useRouteMatch } from "react-router";
import { Content } from "../../../../components/light/Content";
import { SectionBlock } from "../../../../components/light/SectionBlock";
import { Loading } from "../../../../components/Loading";
import { Graph } from "../../../../generated/graph";
import { ProductDraftContent, ProductDraftContentImage } from "../../../../lib/interface/InterfaceProduct";
import { PhotoColorListEditor } from "./components/PhotoColorItem";
import ProductEditContentBarcodeEditor from "./components/ProductEditContentBarcodeEditor";

const SUPPLIER_REQUEST = gql`
  query supplierProductRequest($id: Int!) {
    supplierProductRequest(id: $id) {
      id
      content
      status
      rejectedReason
    }
  }
`;

const UPDATE_SUPPLIER_PRODUCT = gql`
  mutation updateSupplierProductRequest($id: Int!, $content: JSON, $status: Int!) {
    updateSupplierProductRequest(id: $id, content: $content, status: $status)
  }
`;

function AdditionalScreenForm({ data }: { data: Graph.SupplierProductRequest }) {
  const content: ProductDraftContent = data.content as ProductDraftContent;
  const { push } = useHistory();

  const [images, setImages] = useState<ProductDraftContentImage[]>([
    { src: content.picture || "", color: content.color_binding || "" },
    ...(content.images || []),
  ]);
  const [video, setVideo] = useState(content.video);
  const [barcodes, setBarcodes] = useState(content.sku_barcode || []);

  const [updateSupplierProductRequest] = useMutation(UPDATE_SUPPLIER_PRODUCT, {
    refetchQueries: ["supplierProductRequestList"],
    onCompleted: (res) => {
      push("/products/items?filter=DRAFTING");
    },
  });

  const colors: string[] = (content.colours || "").split(",");

  const handleOnSubmit = () => {
    const [firstImage, ...otherImages] = images;

    const newContent = {
      ...content,
      video,
      color_binding: firstImage.color,
      images: otherImages,
      sku_barcode: barcodes,
    };

    updateSupplierProductRequest({
      variables: {
        id: data.id,
        content: newContent,
        status: 1,
      },
    });
  };

  return (
    <div>
      <SectionBlock title="Additional Product Information" transparent={true}>
        <small>
          The following fields are not compulsory. You can click Finalize if you don't have this information.
        </small>
      </SectionBlock>
      <div className="row">
        <div className="col-md-6">
          <SectionBlock title="Photo Color Matching" transparent={true}>
            <PhotoColorListEditor colors={colors} onChange={setImages} images={images} />
          </SectionBlock>
          <SectionBlock title="Video link">
            <div className="form-group">
              <label>Youtube video id eg. 7sJZi0grFR4 from https://www.youtube.com/watch?v=7sJZi0grFR4</label>
              <input
                type="text"
                placeholder="Enter video link here..."
                className="form-control"
                onChange={(e) => setVideo(e.currentTarget.value)}
                value={video || ''}
              />
            </div>
          </SectionBlock>
        </div>
        <div className="col-md-6">
          <SectionBlock title="SKU" transparent={true}>
            <ProductEditContentBarcodeEditor value={barcodes} onChange={setBarcodes} />
          </SectionBlock>
        </div>
      </div>

      <button className="btn btn-primary" type="submit" onClick={handleOnSubmit}>
        Finalize
      </button>
    </div>
  );
}

export function AdditionalScreen() {
  const { params } = useRouteMatch<{ id: string }>();
  const { data } = useQuery<Graph.Query>(SUPPLIER_REQUEST, {
    fetchPolicy: "no-cache",
    variables: {
      id: Number(params.id),
    },
  });

  return (
    <Content>
      <SectionBlock title="">
        {data?.supplierProductRequest ? <AdditionalScreenForm data={data?.supplierProductRequest} /> : <Loading />}
      </SectionBlock>
    </Content>
  );
}
